/* eslint-disable react/prop-types */
import './index.scss';
import { ModalProps } from '../../types';
import useHouseMoney from '../../hooks/useHouseMoney';
import ModalExecuteAction from './ModalExecuteAction';
import { JSX } from 'react/jsx-runtime';
import usePiggybank from '../../hooks/usePiggybank';
import useFlexNaira from '../../hooks/useFlexNaira';

function ModalGeneralExecution(props: JSX.IntrinsicAttributes & ModalProps) {
  const allowLoad =
    props.walletKey === 'piggybank' || props.walletKey === 'housemoney' || props.walletKey === 'flexnaira';
  if (!allowLoad) return null;
  const { isLoading, handleHouseMoneyQuickAction } = useHouseMoney();
  const { fixAccountBalance, isLoading: isLoadingPiggybank } = usePiggybank();
  const { generateFlexNairaNuban, isLoading: isLoadingFlexNaira } = useFlexNaira();

  function closeModal() {
    props.setIsOpen(false);
  }

  const isLoadingForButton = isLoading || isLoadingPiggybank || isLoadingFlexNaira;

  const actionExecuter = (password?: string) => {
    if (props.walletKey === 'piggybank') {
      fixAccountBalance(closeModal);
    } else if (props.walletKey === 'flexnaira') {
      generateFlexNairaNuban(closeModal);
    } else {
      handleHouseMoneyQuickAction(closeModal, props.type, undefined, password);
    }
  };

  return (
    <ModalExecuteAction
      {...props}
      action={(password: string) => actionExecuter(password)}
      isLoading={isLoadingForButton}
    />
  );
}

export default ModalGeneralExecution;
